import React from "react";
import BoldTextLanding from "../../../components/atoms/LandingText/BoldtextLanding";
import { useContent, useLanguages } from "../../../hooks/content";
import { Returntext } from "../common/returnText";
import "./termsAndConditions.scss";

function TermsAndConditions() {
  const { lang } = useLanguages();
  const { contentManagementData } = useContent();
  const termsAndConditionsValue = Returntext(
    contentManagementData,
    "Terms_And_Conditions",
    lang
  );
  return (
    <div>
      <div className="terms_conditions">
        <BoldTextLanding
          text={Returntext(
            contentManagementData,
            "title_terms_and_conditions",
            lang
          )}
          text_color="#000000"
          text_size="48px"
        />
      </div>
      <div className="cont1">
        <div
          className="wrap"
          dangerouslySetInnerHTML={{ __html: termsAndConditionsValue }}
        />
      </div>
    </div>
  );
}

export default TermsAndConditions;
